import { Component, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { createChartSingle } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import html2canvas from 'html2canvas';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

interface Month {
  key: number;
  name: string;
}

@Component({
  selector: 'app-attrition-score-exp-wise',
  templateUrl: './attrition-score-exp-wise.component.html',
  styleUrls: ['./attrition-score-exp-wise.component.scss'],
})
export class AttritionScoreExpWiseComponent implements OnInit {

  isUserEmployee: boolean = false;

  graphType: string = 'bar';  // Default chart type

  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID: any;

  selectedYearForCompetency: any = null;
  selectedYear: any = null;
  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;

  previousMonthsCountJanDec: any;
  previousMonthsCountAprilMarch: any;

  constructor(private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config,
    public sharedService: SharedService, private PdfDownload: PdfDownloadService
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.updateYearControl(this.loggedInCompanyFiscalyear);
    // this.getAllFunctionsByYearRangeReport();
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`;
  //       } else {
  //         yearValue = `${currentYear}-${currentYear + 1}`;
  //       }

  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         var test = ele?.year?.split('-');

  //       }
  //     });
  //     if (this.pmsYears.length > 1) {
  //       this.selectedYearForCompetency = this.pmsYears[1].year;
  //     } else if (this.pmsYears.length > 0) {
  //       this.selectedYearForCompetency = this.pmsYears[0].year;
  //     } else {
  //       console.warn('pmsYears array is empty');
  //       return;
  //     }
  //     this.selectedYear = this.selectedYearForCompetency;

  //     // Call additional functions if needed
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
  //       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
  //       // Add your logic here
  //     }
  //     var year = this.selectedYearForCompetency?.split('-');
  //     if (year?.length != 0) {
  //       this.fromYear = year[0];
  //       this.toYear = year[1];
  //     }

  //     this.getMonths(this.fromYear, this.toYear)
  //     // this.selectedMonth = new Date().getMonth() + 1;
  //     // console.log(this.selectedMonth)
  //   });
  // }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];
  
  //     const currentYear = new Date().getFullYear(); 
  
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       let test = ele.split('_');
  //       let fromYear = parseInt(test[0]);
  //       let toYear = parseInt(test[1]);
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         if (toYear <= currentYear) { 
  //           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
  //         }
  //       } else { 
  //         if (toYear <= currentYear + 1) {
  //           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
  //         }
  //       }
  //     });
  
  //     this.pmsYears.sort((a: { year: string }, b: { year: string }) => {
  //       let [aStart, aEnd] = a.year.split('-').map(Number);
  //       let [bStart, bEnd] = b.year.split('-').map(Number);
  //       return bEnd - aEnd; 
  //     });
  
  //     if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       this.selectedYearForCompetency = `${currentYear}-${currentYear}`; 
  //     } else {
  //       this.selectedYearForCompetency = `${currentYear}-${currentYear + 1}`;
  //     }
  
  //     console.log("Selected Fiscal Year:", this.selectedYearForCompetency);
  
  //     console.log("Final Dropdown Options:", this.pmsYears);
  
  //     this.selectedYear = this.selectedYearForCompetency;
  
  //     let year = this.selectedYearForCompetency?.split('-');
  //     if (year?.length != 0) {
  //       this.fromYear = year[0];
  //       this.toYear = year[1];
  //     }
  
  //     this.getMonths(this.fromYear, this.toYear);
  //   });
  // }

    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
        this.setSelectedYear(yearValue);

        this.getMonths(this.fromYear, this.toYear);
      });
    }
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            this.selectedYearForCompetency = selectedYearObj?.year;
           
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
      }
    }
  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;
    console.log(this.selectedYearForCompetency)
    this.getMonths(this.fromYear, this.toYear)

  }

  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];

  selectedMonthName: any;



  getMonths(fromYear: any, toYear: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec') ? this.fiscalYearMonthsJanDec : this.fiscalYearMonthsAprilMarch;
    this.selectedMonth = new Date().getMonth() + 1;
    console.log(this.selectedMonth);


    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January

    console.log('Selected Month Name:', this.selectedMonthName, "selectedMonth", this.selectedMonth, "previousMonthsCountAprilMarch", this.previousMonthsCountAprilMarch, "previousMonthsCountJanDec", this.previousMonthsCountJanDec);
    this.fetchPerformanceBuckets();
    this.fetchYearBuckets();
    this.fetchPotentialBuckets();

  }

  onMonthChange(event: any) {
    const selectedMonthKey = event.value;
    this.selectedMonth = selectedMonthKey;
    console.log('Selected month key:', this.selectedMonth);

    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    // Recalculate previousMonthsCountAprilMarch
    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Recalculate previousMonthsCountJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January

    this.fetchYearBuckets();
    this.fetchPmsScoreData();
    this.fetchPerformanceBuckets();
    this.fetchYearBuckets();
    this.fetchPotentialBuckets();
  }

  switchGraphType(type: string) {
    this.graphType = type;
  }

  selectGraphType: any = 'bar';
  selectedFromDated: any;
  selectedtoDated: any;
  taskFromDate: any;
  taskToDate: any;

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }

  downloadChartAsPDF(type: string): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    const MonthName = this.selectedMonthName;
    // const formattedToDate = this.selectedtoDated ? formatDate(this.selectedtoDated) : '';

    const idMapping: { [key: string]: string } = {
      'PMS Score Range': this.isPmsScoreRangeTable ? 'table-PMS-Score-Range-data' : 'pms-score-range-chart',
      'Experience in Company':this.isExperienceAttritionRateTable ?'table-Exp-Attrition-data': 'experience-attrition-chart',
      'Potential Score Range': this.isPotentialScoreRangeTable? 'table-Potential-Score-Range-data':'potential-score-range-chart',
      'ESS Score Wise': '',
      '9 Box category wise': ''
    };


    const idSelector = idMapping[type] || 'default-chart-id';
    const element = document.getElementById(idSelector);

    if (!element) {
        console.error('Chart element not found:', idSelector);
        return;
    }

    // // Capture screenshot
    // html2canvas(element).then((canvas) => {
    //     const image = canvas.toDataURL('image/png');
    //     const link = document.createElement('a');
    //     link.href = image;
    //     link.download = `${type}-${todayDate}.png`;
    //     link.click();
    // }).catch(error => console.error('Error capturing chart:', error));
    const selectedYearForReimbursement = this.loggedInCompanyFiscalyear === "Jan_Dec"
      ? this.selectedYearForCompetency.split("-")[0]
      : this.selectedYearForCompetency;

    // Call the common function from the service
    this.PdfDownload.downloadPDFMonthwise(
      idSelector, // Chart ID
      type, // Title
      selectedYearForReimbursement, // Year
      MonthName, // From Date
      // formattedToDate // To Date
    );
  }
  downloadGraph() { }
  // -------------------------- Experience in Company -----------------------------
  public isExperienceAttritionRateIcon: string = 'bar';
  public isExperienceAttritionRateTable: boolean = false;
  public isExperienceAttritionTableGraph: any[] = [];
  public selectGraphExperienceAttritionType: any = 'bar';
  public selectGraphExperienceType: any = 'bar';
  public isExperienceTableGraph: any = [];
  public experienceAttrition: any;
  public yearBuckets: any;

  

  experienceAttritionRate(graphType: any) {
    this.selectGraphExperienceAttritionType = graphType;
    this.isExperienceAttritionRateIcon = graphType;
    this.isExperienceAttritionRateTable = false;
    this.experienceAttritionGraph(this.selectGraphExperienceAttritionType);
  }

  experienceAttritionRateTable() {
    this.selectGraphExperienceType = 'table';
    this.isExperienceAttritionRateIcon = '';
    this.isExperienceAttritionRateTable = true;
  }

  experienceAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  experienceAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  fetchYearBuckets(): void {
    this.httpService.callGetService(`${this.config.yearBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.yearBuckets = data.data;
          console.log('yearBuckets', this.yearBuckets);
          this.fetchExperienceAttrition();
        },
        error: (err) => {
          console.error('Error fetching year buckets:', err);
        }
      });
  }
  fetchExperienceAttrition(): void {
    this.httpService.callGetService(`${this.config.attritionExperienceDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}&month=${this.selectedMonth}`)
      .subscribe({
        next: (data: any) => {
          this.experienceAttrition = data;
          console.log('Experience Attrition:', this.experienceAttrition);
          this.experienceAttritionGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching experience attrition:', err);
        }
      });
  }
  experienceAttritionGraph(graphType: string) {
    console.log("Experience Data:", this.experienceAttrition);
  
    if (!this.experienceAttrition?.data?.length || !this.yearBuckets?.length) {
      console.warn("Data Not Found: Experience data or Experience Buckets are missing");
      this.isExperienceTableGraph = [];
      const chartElement = document.getElementById('experience-attrition-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }
  
    const experienceData = this.experienceAttrition.data[0];
  
    // Create maps for exit, active, and existing users grouped by ExpInYear
    const exitUsersMap = new Map<number, number>();
    const activeUsersMap = new Map<number, number>();
    const existingUsersMap = new Map<number, number>();
  
    experienceData.AllExitInBetweenUser?.forEach((user: { ExpInYear: number; count: number }) => {
      exitUsersMap.set(user.ExpInYear, (exitUsersMap.get(user.ExpInYear) || 0) + user.count);
    });
  
    experienceData.AllActiveUsers?.forEach((user: { ExpInYear: number; count: number }) => {
      activeUsersMap.set(user.ExpInYear, (activeUsersMap.get(user.ExpInYear) || 0) + user.count);
    });
  
    experienceData.AllExistsUsers?.forEach((user: { ExpInYear: number; count: number }) => {
      existingUsersMap.set(user.ExpInYear, (existingUsersMap.get(user.ExpInYear) || 0) + user.count);
    });
  
    // Compute final active users = AllActiveUsers - AllExistsUsers
    const finalActiveUsersMap = new Map<number, number>();
    activeUsersMap.forEach((count, exp) => {
      finalActiveUsersMap.set(exp, count - (existingUsersMap.get(exp) || 0));
    });
  
    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? this.previousMonthsCountJanDec
        : this.previousMonthsCountAprilMarch;
  
    // Transform data dynamically based on yearBuckets
    const transformedData = this.yearBuckets.map((bucket: any) => {
      const range = `${bucket.yearBucketLow}-${bucket.yearBucketMax}`;
      const min = bucket.yearBucketLow;
      const max = bucket.yearBucketMax;
  
      // Compute exit user count for the given range
      let exitCount = 0;
      for (let i = min; i < max; i++) {
        exitCount += exitUsersMap.get(i) || 0;
      }
  
      // Compute active user count for the given range
      let activeUserCount = 0;
      for (let i = min; i < max; i++) {
        activeUserCount += finalActiveUsersMap.get(i) || 0;
      }
  
      // Compute attrition percentage and annualized attrition
      const attritionPercentage = activeUserCount > 0 ? ((exitCount / activeUserCount) * 100).toFixed(2) : '0';
      const annualizedAttrition = ((+attritionPercentage * 12) / previousMonthsCount).toFixed(2);
  
      return graphType === 'pie'
        ? {
            name: range,
            value: exitCount,
            attritionPercentage,
            annualizedAttrition
          }
        : {
            xAxisValueData: range,
            seriesValueOneData: exitCount,
            seriesValueTwoData: +attritionPercentage,
            seriesValueThreeData: annualizedAttrition,
            xAxisName: 'Years of Experience',
            yAxisName: 'Employee Count',
            seriesLabelOne: 'Employee Count',
            seriesLabelTwo: 'Attrition %',
            seriesLabelThree: 'Annualized Attrition %'
          };
    });
  
    console.log("Transformed Experience Data:", transformedData);
    this.isExperienceTableGraph = transformedData;
  
    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('experience-attrition-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = { xAxisName: 'Experience Buckets', yAxisName: 'Count' };
      const graphFunctions: Record<string, Function> = {
        bar: this.experienceAttritionBarGraph,
        line: this.experienceAttritionLineGraph
      };
  
      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'experience-attrition-chart', 'single', seriesLabels);
      }
    }
  }
  
  // --------------------------PMS Score Range-----------------------------
  public isPmsScoreRangeIcon: string = 'bar';
  public isPmsScoreRangeTable: boolean = false;
  public isPmsScoreTableGraph: any[] = [];
  public selectGraphPmsScoreType: any = 'bar';
  public isPmsTableGraph: any = [];
  public pmsScoreData: any;
  public performanceBuckets: any;
  fetchPerformanceBuckets(): void {
    this.httpService.callGetService(`${this.config.performanceBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.performanceBuckets = data.data;
          console.log('performanceBuckets', this.performanceBuckets);
          this.fetchPmsScoreData();
        },
        error: (err) => {
          console.error('Error fetching performance buckets:', err);
        }
      });
  }

  fetchPmsScoreData(): void {
    this.httpService.callGetService(`${this.config.pmsScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}&month=${this.selectedMonth}`)
      .subscribe({
        next: (data: any) => {
          this.pmsScoreData = data;
          console.log('PMS Score Data:', this.pmsScoreData);
          this.pmsScoreGraph('bar');
        },
        error: (err) => {
          console.error('Error fetching PMS Score Data:', err);
        }
      });
  }

  pmsScoreRange(graphType: any) {
    this.selectGraphPmsScoreType = graphType;
    this.isPmsScoreRangeIcon = graphType;
    this.isPmsScoreRangeTable = false;
    this.pmsScoreGraph(this.selectGraphPmsScoreType);
  }

  pmsScoreRangeTable() {
    this.selectGraphPmsScoreType = 'table';
    this.isPmsScoreRangeIcon = '';
    this.isPmsScoreRangeTable = true;
  }

  PMSScoreAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  PMSScoreAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
    createChartSingle(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }
  pmsScoreGraph(graphType: string) {
    console.log("PMS Score Data:", this.pmsScoreData);

    if (!this.pmsScoreData?.data?.length || !this.performanceBuckets?.length) {
      console.warn("Data Not Found: PMS Score data or Performance Buckets are missing");
      // Reset variables to avoid displaying stale data
      this.isPmsScoreTableGraph = [];

      // If using a chart, clear it
      const chartElement = document.getElementById('pms-score-range-chart') as HTMLDivElement;
      if (chartElement) {
        echarts.init(chartElement).clear();
      }
      return;
    }

    const previousMonthsCount =
      this.loggedInCompanyFiscalyear === "Jan_Dec"
        ? this.previousMonthsCountJanDec
        : this.previousMonthsCountAprilMarch;

    // Map PMS Score Data to Performance Buckets
    const performanceBucketRange = this.performanceBuckets.map((bucket: any) => ({
      range: `${bucket.lowerEnd}-${bucket.upperEnd}`,
      count: 0
    }));

    // Categorize PMS Score Data
    this.pmsScoreData.data.forEach((score: any) => {
      const kpiScore = score.kpiScore;
      const bucket = performanceBucketRange.find((b: any) =>
        kpiScore >= +b.range.split('-')[0] && kpiScore < +b.range.split('-')[1]
      );
      if (bucket) {
        bucket.count += 1; // Count users in each bucket
      }
    });

    let transformedData: any[] = [];
    if (graphType === 'pie') {
      transformedData = performanceBucketRange.map((bucket: any) => ({
        name: bucket.range,
        value: bucket.count,
        attritionPercentage: ((bucket.count / this.pmsScoreData.data.length) * 100).toFixed(2),
        annualizedAttrition: ((+bucket.count * 12) / previousMonthsCount).toFixed(2)
      }));
    } else {
      transformedData = performanceBucketRange.map((bucket: any) => ({
        xAxisValueData: bucket.range,
        seriesValueOneData: bucket.count,
        seriesValueTwoData: +((bucket.count / this.pmsScoreData.data.length) * 100).toFixed(2),
        seriesValueThreeData: +((bucket.count * 12) / previousMonthsCount).toFixed(2),
        xAxisName: 'Performance Score Range',
        yAxisName: 'User Count',
        seriesLabelOne: 'Users Count',
        seriesLabelTwo: 'Attrition %',
        seriesLabelThree: 'Annualized Attrition %'
      }));
    }

    console.log("Transformed PMS Score Data:", transformedData);
    this.isPmsScoreTableGraph = transformedData;

    if (graphType === 'pie') {
      const pieChartOptions = this.attritionPieChartOptions(transformedData);
      echarts.init(document.getElementById('pms-score-range-chart') as HTMLDivElement).setOption(pieChartOptions);
    } else {
      const seriesLabels = {
        xAxisName: 'Performance Score',
        yAxisName: 'Attrition Count'
      };

      const graphFunctions: Record<string, Function> = {
        bar: this.PMSScoreAttritionBarGraph,
        line: this.PMSScoreAttritionLineGraph
      };

      const renderGraph = graphFunctions[graphType];
      if (renderGraph) {
        renderGraph.call(this, transformedData, 'pms-score-range-chart', 'single', seriesLabels);
      }
    }
  }
    // --------------------------Potential Score Range-----------------------------
    public isPotentialScoreRangeIcon: string = 'bar';
    public isPotentialScoreRangeTable: boolean = false;
    public isPotentialScoreTableGraph: any[] = [];
    public selectGraphPotentialScoreType: any = 'bar';
    public isPotentialTableGraph: any = [];
    public potentialScoreData: any;
    public potentialBuckets: any;
    
    fetchPotentialBuckets(): void {
      this.httpService.callGetService(`${this.config.potentialBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
        .subscribe({
          next: (data: any) => {
            this.potentialBuckets = data.data;
            console.log('Potential Buckets', this.potentialBuckets);
            this.fetchPotentialScoreData();
          },
          error: (err) => {
            console.error('Error fetching potential buckets:', err);
          }
        });
    }
  
    fetchPotentialScoreData(): void {
      this.httpService.callGetService(`${this.config.potentialScoreDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
        .subscribe({
          next: (data: any) => {
            this.potentialScoreData = data;
            console.log('Potential Score Data:', this.potentialScoreData);
            this.potentialScoreGraph('bar');
          },
          error: (err) => {
            console.error('Error fetching Potential Score Data:', err);
          }
        });
    }
  
    potentialScoreRange(graphType: any) {
      this.selectGraphPotentialScoreType = graphType;
      this.isPotentialScoreRangeIcon = graphType;
      this.isPotentialScoreRangeTable = false;
      this.potentialScoreGraph(this.selectGraphPotentialScoreType);
    }
  
    potentialScoreRangeTable() {
      this.selectGraphPotentialScoreType = 'table';
      this.isPotentialScoreRangeIcon = '';
      this.isPotentialScoreRangeTable = true;
    }
  
    PotentialScoreAttritionLineGraph(data: any, idSelector: any, graphType: any): void {
      createChartSingle(idSelector, 'line', graphType, data, {
        xAxisName: data.xAxisName,
        yAxisName: data.yAxisName,
      });
    }
  
    PotentialScoreAttritionBarGraph(data: any, idSelector: any, graphType: any): void {
      createChartSingle(idSelector, 'bar', graphType, data, {
        xAxisName: data.xAxisName,
        yAxisName: data.yAxisName,
      });
    }
    
    potentialScoreGraph(graphType: string) {
      console.log("Potential Score Data:", this.potentialScoreData);
  
      if (!this.potentialScoreData?.data?.length || !this.potentialBuckets?.length) {
        console.warn("Data Not Found: Potential Score data or Potential Buckets are missing");
        this.isPotentialScoreTableGraph = [];
        const chartElement = document.getElementById('potential-score-range-chart') as HTMLDivElement;
        if (chartElement) {
          echarts.init(chartElement).clear();
        }
        return;
      }
  
      const previousMonthsCount =
        this.loggedInCompanyFiscalyear === "Jan_Dec"
          ? this.previousMonthsCountJanDec
          : this.previousMonthsCountAprilMarch;
  
      const potentialBucketRange = this.potentialBuckets.map((bucket: any) => ({
        range: `${bucket.lowerEnd}-${bucket.upperEnd}`,
        count: 0
      }));
  
      this.potentialScoreData.data.forEach((score: any) => {
        const kpiScore = score.Potential;
        const bucket = potentialBucketRange.find((b: any) =>
          kpiScore >= +b.range.split('-')[0] && kpiScore < +b.range.split('-')[1]
        );
        if (bucket) {
          bucket.count += 1;
        }
      });
  
      let transformedData: any[] = [];
      if (graphType === 'pie') {
        transformedData = potentialBucketRange.map((bucket: any) => ({
          name: bucket.range,
          value: bucket.count,
          attritionPercentage: ((bucket.count / this.potentialScoreData.data.length) * 100).toFixed(2),
          annualizedAttrition: ((+bucket.count * 12) / previousMonthsCount).toFixed(2)
        }));
      } else {
        transformedData = potentialBucketRange.map((bucket: any) => ({
          xAxisValueData: bucket.range,
          seriesValueOneData: bucket.count,
          seriesValueTwoData: +((bucket.count / this.potentialScoreData.data.length) * 100).toFixed(2),
          seriesValueThreeData: +((bucket.count * 12) / previousMonthsCount).toFixed(2),
          xAxisName: 'Potential Score Range',
          yAxisName: 'User Count',
          seriesLabelOne: 'Users Count',
          seriesLabelTwo: 'Attrition %',
          seriesLabelThree: 'Annualized Attrition %'
        }));
      }
  
      console.log("Transformed Potential Score Data:", transformedData);
      this.isPotentialScoreTableGraph = transformedData;
  
      if (graphType === 'pie') {
        const pieChartOptions = this.attritionPieChartOptions(transformedData);
        echarts.init(document.getElementById('potential-score-range-chart') as HTMLDivElement).setOption(pieChartOptions);
      } else {
        const seriesLabels = {
          xAxisName: 'Potential Score',
          yAxisName: 'Attrition Count'
        };
  
        const graphFunctions: Record<string, Function> = {
          bar: this.PotentialScoreAttritionBarGraph,
          line: this.PotentialScoreAttritionLineGraph
        };
  
        const renderGraph = graphFunctions[graphType];
        if (renderGraph) {
          renderGraph.call(this, transformedData, 'potential-score-range-chart', 'single', seriesLabels);
        }
      }
    }
  

  //------------------Pie Chart------------------
  attritionPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          // console.log(params);

          // Extract all available data dynamically
          let tooltipContent = `<strong>${params.name}</strong><br/>`;
          Object.keys(params.data).forEach((key) => {
            if (key !== 'name' && key !== 'value') {
              const formattedKey = key.replace(/([A-Z])/g, ' $1').trim(); // Convert camelCase to spaced words
              tooltipContent += `${formattedKey}: <strong>${params.data[key]}</strong><br/>`;
            }
          });

          return tooltipContent;
        }
      },
      legend: {
        bottom: 0
      },
      color: [
        '#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858',
        '#9A60B4', '#EA7CCC', '#3BA${this.loggedInUserCompanyID}', '#FC8452', '#B4A7D6'
      ],
      series: [
        {
          name: 'Department',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: (params: any) => {
              return `${params.name}: ${params.value}`; // Dynamic label with department & count
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
}
